module.exports = __webpack_public_path__ + "img/footer.d7651c92.jpg";